// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import EndUserTokenConstants from 'constants/EndUserTokenConstants'

const EndUserTokenStore = Marty.createStore({
  id: 'EndUserTokenStore',

  getInitialState() { return {
    endUserTokens: {}
  } },

  handlers: {
    getEndUserTokenDone: EndUserTokenConstants.GET_END_USER_TOKEN_DONE
  },

  getEndUserToken(orgId, email, leadId, userId, version) {
    const key = `${ orgId }-${ email || leadId || userId }`
    return this.fetch({
      id: `getEndUserToken${ key }`,
      locally() {
        return this.state.endUserTokens[key]
      },
      remotely() {
        return this.app.queries.EndUserTokenQueries.getEndUserToken(orgId, email, leadId, userId, version)
      }
    })
  },

  getEndUserTokenDone(orgId, email, leadId, userId, data) {
    const tokens = _.cloneDeep(this.state.endUserTokens)
    tokens[`${ orgId }-${ email || leadId || userId }`] = data
    return this.setState({ endUserTokens: tokens })
  }
})

export default EndUserTokenStore



// WEBPACK FOOTER //
// ./src/scripts/stores/EndUserTokenStore.js